import React, { useEffect } from "react";
import { IonCard, IonCardHeader, IonCardTitle, IonList } from "@ionic/react";
import { useIntl } from "react-intl";
import VisitItem from "./VisitItem";
import { useDispatch, useSelector } from "react-redux";
import { loadPatienthouseVisits } from "../patientSlice";

const Visits = (props) => {
  const { activePatient, patientId, branchId } = props;
  const intl = useIntl();
  const dispatch = useDispatch();
  const { houseVisits } = useSelector((state) => state.patient);
  const { items } = houseVisits;

  useEffect(() => {
    if (activePatient.id) {
      dispatch(loadPatienthouseVisits());
    }
  }, [activePatient, dispatch]);

  return items && items.length > 0 ? (
    <IonCard>
      <IonCardHeader>
        <IonCardTitle>
          {intl.formatMessage({
            id: "app.mobile.visits",
          })}
        </IonCardTitle>
      </IonCardHeader>
      <IonList>
        {items.map((item) => (
          <VisitItem
            key={item.id}
            item={item}
            patientId={patientId}
            branchId={branchId}
          />
        ))}
      </IonList>
    </IonCard>
  ) : null;
};

export default Visits;
